const CommentBlock03Icon = /*#__PURE__*/ [
  ["path", { d: "M9.6 8.05L14.5 12.95M15.55 10.5C15.55 8.567 13.983 7 12.05 7C10.117 7 8.55 8.567 8.55 10.5C8.55 12.433 10.117 14 12.05 14C13.983 14 15.55 12.433 15.55 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 10.5C2 5.5 6 3 12 3C18 3 22 5.5 22 10.5C22 15.5 18 18 12 18V21C12 21 2 18 2 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CommentBlock03Icon as default };
//# sourceMappingURL=CommentBlock03Icon.js.map
